// supabase-js emite SIGNED_IN cada vez que la pestaña recupera el foco
// (GoTrueClient._recoverAndRefresh), no solo en un login real. Este marcador
// (solo el uid, metadata de sesión) evita auditar un 'login' por cada foco.
// Se limpia en SIGNED_OUT, así que un login real posterior sí se registra.
const KEY = 'quipus_login_audited_uid';

/** true si hay que auditar este SIGNED_IN (primera vez para este uid desde el último logout). */
export function shouldAuditLogin(userId: string, storage: Pick<Storage, 'getItem' | 'setItem'> = localStorage): boolean {
  try {
    if (storage.getItem(KEY) === userId) return false;
    storage.setItem(KEY, userId);
  } catch {
    // Storage no disponible: mejor auditar de más que perder un login real.
  }
  return true;
}

export function clearLoginAuditMarker(storage: Pick<Storage, 'removeItem'> = localStorage): void {
  try {
    storage.removeItem(KEY);
  } catch {
    // sin storage no hay marcador que limpiar
  }
}
